import classNames from "classnames";
import React from "react";
import { CalendarMode } from "..";

// DEVNOTE: consider migrating to packages/design-system/src/components/ButtonGroup.tsx
export const CalendarModeToggle = ({
  calendarMode,
  onCalendarModeChange,
}: {
  calendarMode: CalendarMode;
  onCalendarModeChange: (view: CalendarMode) => void;
}) => {
  const weekSelected = calendarMode === "week";

  return (
    <ButtonGroup ariaLabel="calendar mode toggle">
      <ButtonGroupItem
        isSelected={!weekSelected}
        onCalendarModeChange={() => onCalendarModeChange("day")}
        position="first"
      >
        Day
      </ButtonGroupItem>
      <ButtonGroupItem
        isSelected={weekSelected}
        onCalendarModeChange={() => onCalendarModeChange("week")}
        position="last"
      >
        Week
      </ButtonGroupItem>
    </ButtonGroup>
  );
};

const ButtonGroup = ({ children, ariaLabel }: { children: React.ReactNode; ariaLabel: string }) => {
  return (
    <div aria-label={ariaLabel} className="cw-flex">
      {children}
    </div>
  );
};

const ButtonGroupItem = ({
  children,
  isSelected,
  onCalendarModeChange,
  position,
}: {
  children: React.ReactNode;
  isSelected: boolean;
  onCalendarModeChange: (view: CalendarMode) => void;
  position: "first" | "last";
}) => {
  return (
    <button
      onClick={() => onCalendarModeChange("week")}
      className={classNames(
        "cw-body-sm cw-py-[3px] cw-w-[70px] cw-cursor-pointer cw-font-medium",
        {
          "cw-rounded-l-md": position === "first",
          "cw-rounded-r-md": position === "last",
        },
        isSelected
          ? [
              `cw-bg-default hover:cw-bg-default-hover`,
              `cw-text-default`,
              `cw-border cw-border-solid cw-border-default`,
            ]
          : [
              `cw-bg-neutral-inset hover:cw-bg-neutral-inset-hover`,
              `cw-text-muted`,
              `cw-border cw-border-solid cw-border-subtle`,
            ],
      )}
    >
      {children}
    </button>
  );
};
